var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useEffect, useRef, useState } from 'react';
import { Context } from '../../contexts/map';
import { useEvents, usePrevious } from '../../hooks';
import { BOUNDS_ANIMATION, CENTER_ANIMATION, ZOOM_ANIMATION } from '../animation';
import { container, map as mapStyle } from './styles';
var YMap = function (props) {
    var children = props.children, state = props.state, options = props.options, center = props.center, zoom = props.zoom, bounds = props.bounds, events = props.events;
    var element = useRef();
    var prev = usePrevious(props);
    var _a = useState(), map = _a[0], setMap = _a[1];
    // Запускается один раз
    useEffect(function () {
        if (map) {
            return;
        }
        var finalState = __assign({}, state);
        if (bounds) {
            finalState.bounds = bounds;
        }
        else if (center && zoom) {
            finalState.center = center;
            finalState.zoom = zoom;
        }
        else {
            // tslint:disable-next-line:no-console
            console.log('Для создания карты необходимо задать `center` и `zoom` или `bounds`');
            return;
        }
        setMap(new ymaps.Map(element.current, finalState, options));
    }, [bounds, center, map, options, state, zoom]);
    useEffect(function () { return function () {
        if (map) {
            map.destroy();
            setMap(null);
        }
    }; }, [map]);
    useEffect(function () {
        if (!map) {
            return;
        }
        if (center !== prev.center && zoom !== prev.zoom) {
            map.setCenter(center, zoom, prev.centerAnimation === undefined
                ? CENTER_ANIMATION
                : prev.centerAnimation);
        }
        else if (center !== prev.center) {
            map.setCenter(center, undefined, prev.centerAnimation === undefined
                ? CENTER_ANIMATION
                : prev.centerAnimation);
        }
        else if (zoom !== prev.zoom) {
            map.setZoom(zoom, prev.zoomAnimation === undefined ? ZOOM_ANIMATION : prev.zoomAnimation);
        }
    }, [center, map, prev, zoom]);
    useEffect(function () {
        if (map && bounds !== prev.bounds) {
            map.setBounds(bounds, prev.boundsAnimation === undefined
                ? BOUNDS_ANIMATION
                : prev.boundsAnimation);
        }
    }, [bounds, map, prev]);
    useEvents(map, events);
    var content = children instanceof Function
        ? children({ loading: !map })
        : map && React.createElement(Context.Provider, { value: map }, children);
    return (React.createElement("section", { style: container },
        React.createElement("div", { style: mapStyle, ref: element }),
        content));
};
export default memo(YMap);
